export default __webpack_public_path__ + "static/media/2.fa9f027a.png";